// extracted by mini-css-extract-plugin
export var audioPlayer = "_ru-0";